// ** Auth Endpoints
import urls from  './urls'
export default {
  loginEndpoint: `${urls.url}/login/`,
  registerEndpoint: `${urls.url}/signup/`,
  refreshEndpoint: `${urls.url}/token/refresh/`,
  logoutEndpoint: `${urls.url}/logout/`,

  // ** This will be prefixed in authorization header with token
  // ? e.g. Authorization: Bearer <token>
  tokenType: 'Bearer',

  // ** Value of this property will be used as key to store JWT token in storage
  storageTokenKeyName: 'token',
  storageRefreshTokenKeyName: 'refreshToken'
}
